/**
 * @file Submission read-only / review UI components — DatasetOverviewConditionalContent.tsx.
 */

import React from "react";

/** Type definition — Dataset Overview Conditional Content Props. */
export type DatasetOverviewConditionalContentProps = {
  /** When false, shows placeholder instead of form body. */
  show: boolean;
  placeholder?: React.ReactNode;
  children: React.ReactNode;
};

/** Lifecycle sections: show form when Background flag is on, else placeholder. */
const DatasetOverviewConditionalContent: React.FC<
  DatasetOverviewConditionalContentProps
> = ({ show, placeholder, children }) => {
  if (!show) return <>{placeholder}</>;
  return <>{children}</>;
};

/** React component — Dataset Overview Conditional Content. */
export default DatasetOverviewConditionalContent;
